<template>
  <div v-show="visible" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring spinner-ring-2"></div>
      <div class="spinner-dot"></div>
    </div>
    <div class="loading-text"><span class="thinking-text">{{ text }}<span class="thinking-dots"></span></span></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '加载中'
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(245, 245, 245, 0.85);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
}

.spinner-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 52px;
  height: 52px;
  margin: -26px 0 0 -26px;
  border: 3px solid transparent;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: spinnerSpin 1.2s linear infinite;
}

.spinner-ring-2 {
  width: 38px;
  height: 38px;
  margin: -19px 0 0 -19px;
  border-top-color: #67c23a;
  animation-duration: 0.9s;
  animation-direction: reverse;
}

.spinner-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  margin: -5px 0 0 -5px;
  background: #409eff;
  border-radius: 50%;
  animation: dotPulse 1.5s ease-in-out infinite;
}

@keyframes spinnerSpin {
  to { transform: rotate(360deg); }
}

@keyframes dotPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.6); opacity: 0.6; }
}

.loading-text {
  font-size: 16px;
  color: #606266;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.thinking-text {
  color: #409eff;
  font-style: italic;
}

.thinking-dots {
  display: inline-flex;
  align-items: center;
}

.thinking-dots::after {
  content: '';
  animation: thinkingDots 1.5s infinite;
}

@keyframes thinkingDots {
  0%, 60%, 100% { content: '.'; }
  20% { content: '..'; }
  40% { content: '...'; }
}
</style>
